/**
 * Pódio: três lugares, três montras, uma visível de cada vez.
 *
 * Troca-se ao clicar, e só ao clicar. Sem relógio e sem reagir ao rato a
 * passar por cima: quem está a ler não fica a ver o conteúdo mudar-lhe à
 * frente, nem troca de produto sem querer ao atravessar a secção com o rato.
 *
 * As montras já vêm todas no HTML, escondidas com `hidden`: trocar de produto
 * não pede nada ao servidor, e quem não tiver JavaScript vê a primeira.
 */
class ClaroPodio extends HTMLElement {
  #botoes = [];
  #paineis = [];

  connectedCallback() {
    this.#botoes = [...this.querySelectorAll('[data-claro-podio]')];
    this.#paineis = [...this.querySelectorAll('[data-claro-painel]')];
    if (this.#botoes.length < 2) return;

    this.#botoes.forEach((botao, i) => botao.addEventListener('click', () => this.#mostra(i)));
  }

  #mostra(indice) {
    const alvo = String(indice);

    this.#botoes.forEach((botao) =>
      botao.setAttribute('aria-selected', String(botao.dataset.claroPodio === alvo))
    );

    this.#paineis.forEach((painel) => {
      painel.hidden = painel.dataset.claroPainel !== alvo;
    });
  }
}

if (!customElements.get('claro-podio')) customElements.define('claro-podio', ClaroPodio);
